/**
 * axios封装
 * 请求拦截、响应拦截、错误统一处理
 */
import axios from 'axios'
import rootVm from '@/main.js'
import store from '../store'

function isMoreThan30SecondsApart (date1, date2) {
  const difference = Math.abs(date2.getTime() - date1.getTime()) // 计算时间差的绝对值
  return difference < 10000 // 如果差值小于30000毫秒，即30秒，则返回true
}

let newTokenTime = 0
let requickTokenTime = 0

// 创建axios实例
var instance = axios.create({ timeout: 1000 * 12 })
// 设置post请求头
instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

/**
 * 请求拦截器
 * 每次请求前，如果存在token则在请求头中携带token
 */
instance.interceptors.request.use(
  config => {
    // 登录流程控制中，根据本地是否存在token判断用户的登录情况
    // 但是即使token存在，也有可能token是过期的，所以在每次的请求头中携带token
    // 后台根据携带的token判断用户的登录情况，并返回给我们对应的状态码
    // 而后我们可以在响应拦截器中，根据状态码进行一些统一的操作。
    // const token = store.state.token
    // token && (config.headers.Authorization = token)
    if (config && config.headers && config.headers['Authorization']) {
      config.headers['Authorization'] = 'Bearer ' + localStorage.getItem('token')
    }
    return config
  },
  error => Promise.error(error))
// 响应拦截器
instance.interceptors.response.use(
  // 请求成功
  res => {
    console.log('第1111个封装请求js****')
    if (res && res.data && res.data.newtoken) {
      localStorage.setItem('token', res.data.newtoken)
      newTokenTime = new Date()
    }
    if (res.status === 200) {
      let url = res.config.url
      let checkUrl = !(url.indexOf('market/getCompanyLeixing') !== -1) &&
      !(url.indexOf('edu/getRuzhuinfo') !== -1) &&
      !(url.indexOf('talent/getTalentRole') !== -1) &&
      !(url.indexOf('tour/getUserTourRuzhu') !== -1) &&
      !(url.indexOf('own/getRuzhuStatus') !== -1) &&
      !(url.indexOf('information/getRuzhuStatus') !== -1) &&
      !(url.indexOf('live/getLiveRuzhuinfo') !== -1)
      // 白名单 --- 这些接口不用验证是否登录
      if (res.data.code === 101 && checkUrl) {
        requickTokenTime = new Date()
        const nowToken = 'Bearer ' + localStorage.getItem('token')
        if (newTokenTime && isMoreThan30SecondsApart(newTokenTime, requickTokenTime)) { // 相差30s
          // 接口重新请求
          res.config.headers['Authorization'] = nowToken
          return Promise.resolve(instance(res.config))
        } else {
          // 接口超过30s，删除token等
          localStorage.removeItem('userInfo')
          localStorage.removeItem('token')
          console.log( "rootVmrootVmrootVm",rootVm)
          if(url.includes("getUserInfo") && !rootVm._route.path.includes("user/personInfo/base") ){
            return
          }
          store.dispatch('addVerification', 1)
        }
      } else {
        return Promise.resolve(res)
      }
    } else {
      return Promise.reject(res)
    }
  },
  // 请求失败
  error => {
    const { response } = error
    if (response) {
      // 请求已发出，但是不在2xx的范围
      return Promise.reject(response)
    } else {
      // 处理断网的情况
      // eg:请求超时或断网时，更新state的network状态
      // network状态在app.vue中控制着一个全局的断网提示组件的显示隐藏
      // 关于断网组件中的刷新重新获取数据，会在断网组件中说明
    }
  })

export default instance



// WEBPACK FOOTER //
// ./src/axios/index.js